import React from 'react';

const BrandKitIcon: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Palette shape */}
    <path
      d="M9 2C5.13 2 2 5.13 2 9C2 12.87 5.13 16 9 16C9.74 16 10.33 15.41 10.33 14.67C10.33 14.33 10.2 14.03 9.99 13.8C9.79 13.57 9.67 13.27 9.67 12.93C9.67 12.19 10.26 11.6 11 11.6H12.33C14.54 11.6 16 10.22 16 8.2C16 4.78 12.87 2 9 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    {/* Color dots */}
    <circle cx="5.8" cy="7.5" r="1.1" fill="currentColor" />
    <circle cx="8" cy="5.3" r="1.1" fill="currentColor" />
    <circle cx="10.8" cy="6.2" r="1.1" fill="currentColor" />
  </svg>
);

export default BrandKitIcon;
